import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from "../services/AuthService";

const authService = new AuthService();

const SignInCallback: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        authService.userManager.signinRedirectCallback()
            .then(user => {
                if (user) {
                    // const token = user.access_token;
                    navigate('/');  // Redirect to the main application or dashboard.
                } else {
                    // Handle cases where user object might be null or undefined.
                    console.warn("Received unexpected null or undefined user.");
                    navigate('/error');  // Redirect to an error page.
                }
            })
            .catch(error => {
                console.error("Error during signin callback:", error);
                authService.login();
                navigate('/error');  // Redirect to an error page or handle the error differently.
            });
    }, [navigate]);

    // This component can render a loading spinner or some placeholder content while processing the callback.
    return (
        <div>
            Processing sign-in...
            {/* Alternatively, display a spinner or other loading indicator here. */}
        </div>
    );
}

export default SignInCallback;
